export const UNIVERSAL_KEYWORDS_CN = [
  "林炎",
  "上海林炎",
  "林炎工贸",
  "上海林炎工贸有限公司",
  "官方网站",
  "双酚A",
  "BPA",
  "聚碳酸酯",
  "PC",
  "环氧树脂",
  "LER",
  "中国最大BPA",
  "中国最大PC",
  "BPA出口",
  "PC出口"
];

export const UNIVERSAL_KEYWORDS_EN = [
  "LinYan",
  "Shanghai LinYan",
  "LYNYN International",
  "LYNYN International Co., Ltd.",
  "Official Website",
  "Bisphenol A",
  "BPA",
  "Polycarbonate",
  "PC",
  "Epoxy Resin",
  "LER",
  "China Largest BPA",
  "China Largest PC",
  "BPA Export",
  "PC Export"
];

export const getSeoData = (pageTitleCn, pageTitleEn, lang) => {
  const universalKeywords = lang === 0 ? UNIVERSAL_KEYWORDS_CN : UNIVERSAL_KEYWORDS_EN;
  const pageTitle = lang === 0 ? pageTitleCn : pageTitleEn;
  
  // Combine page title with universal keywords
  const keywords = [pageTitle, ...universalKeywords].join(", ");
  
  // Base description
  const descriptionCn = `上海林炎工贸有限公司（林炎）是中国最大的双酚A (BPA)、聚碳酸酯 (PC) 及环氧树脂 (LER) 销售商与出口商。本站为官方网站，提供 ${pageTitleCn} 相关信息及技术资料下载。`;
  const descriptionEn = `LYNYN International Co., Ltd. (LYNYN) is the largest distributor and exporter of Bisphenol A (BPA), Polycarbonate (PC), and Epoxy Resin (LER) in China. Official website providing ${pageTitleEn} and technical documents.`;
  
  return {
    title: `${pageTitle} - ${lang === 0 ? "LYNYN International Co., Ltd." : "LYNYN International Co., Ltd."}`,
    keywords,
    description: lang === 0 ? descriptionCn : descriptionEn
  };
};
